import api from 'http';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import CreatePasswordForm from './CreatePasswordForm';
import LinkExpiredBox from './LinkExpiredBox';
import { PASSWORD_UPDATED_SUCCESSFULLY } from 'Common/ToastConstants';
import AuthWrapper from 'NewComponents/Wrappers/AuthWrapper';
const CreatePasswordPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showLinkExpiredBox, setShowLinkExpiredBox] = useState(false)

    const handleReset = async (key, emailTo, encryptPassword) => {
        try {
            setLoading(true);
            const config = {
                headers: {
                    Authorization: `Bearer ${key}`, // Add any custom headers here
                },
            };
            const payload = {
                email: emailTo,
                newPassword: encryptPassword,
            };
            await api.post(`${process.env.REACT_APP_TC_AUTH}/api/Account/ResetPassword`, payload, config);
            toast.success(PASSWORD_UPDATED_SUCCESSFULLY);
            navigate("/login");
        } catch (error) {
            setLoading(false);

            if (error.response.data.responseMessage === "This link has expired. Please contact your administrator.") {
                setShowLinkExpiredBox(true)

            } else {
                ErrorHandlingMessage(error);

            }
        }
    };

    return (
        <AuthWrapper heading="Create new password" subheading="Enter your new password to update your account.">
            <div className="max-w-md mx-auto mt-10">
                <div className="space-y-6">
                    <CreatePasswordForm
                        handleReset={handleReset}
                        loading={loading}
                    />
                </div>
            </div>
        </AuthWrapper>
    )
}

export default CreatePasswordPage